import React from 'react';
import PropTypes from 'prop-types';
import currencyFormat from 'utils/currencyFormat';
import { Typography } from 'antd';

function CustomTooltip({ active, payload }) {
  if (active && payload && payload.length) {
    const { date, total } = payload[0].payload;
    const bgColor = total >= 0 ? '#009D19' : '#f87171'; // Green or Red
    return (
      <div style={{ '--tooltip-bg': bgColor, padding: '15px' }} className="custom-tooltip">
        <Typography className="tooltip-label">Date: {date}</Typography>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Typography className="tooltip-sub-label">
            {total >= 0 ? 'Earned :' : 'Negative :'}
          </Typography>

          <Typography className="tooltip-value">₹{currencyFormat(total, true, false)}</Typography>
        </div>
      </div>
    );
  }
  return null;
}

CustomTooltip.propTypes = {
  active: PropTypes.bool.isRequired,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      payload: PropTypes.shape({
        date: PropTypes.string.isRequired,
        total: PropTypes.number.isRequired
      }).isRequired
    })
  ).isRequired
};

export default CustomTooltip;
